import type { Country } from '@types'

export default function determineCountry(): Country {
  return 'us'
}
